import styled, { css, keyframes } from 'styled-components';

const slideUp = keyframes`
  from {
    transform: translate(-50%, 100%);
    opacity: 0;
  }
  to {
    transform: translate(-50%, -50%);
    opacity: 1;
  }
`;

const slideDown = keyframes`
  from {
    transform: translate(-50%, -50%);
    opacity: 1;
  }
  to {
    transform: translate(-50%, 100%);
    opacity: 0;
  }
`;

export const AlertStyled = styled.div`
  .alertBox {
    border-radius: 4px;
    background: rgba(51, 51, 51, 0.8);
    box-shadow: 0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px 0px rgba(0, 0, 0, 0.3);
    padding: 14px 16px;

    bottom: ${props => 10 + props.index * 50}px; // 각 알림의 위치를 조정
    position: fixed;
    width: calc(100% - 32px);
    left: 50%;
    transform: translate(-50%, 100%);
    height: fit-content;

    font-family: Pretendard;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;

    z-index: 2000;
    color: #f5eff7;
    animation: ${slideUp} 0.5s forwards;

    &.hide {
      animation: ${slideDown} 0.5s forwards;
    }
  }
`;
